import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import { MaintenanceCheck } from './maintenance';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/pages/Home.vue'),
    meta: {
      title: 'ホーム',
    },
  },
  {
    path: '/schedules/daily',
    component: () => import('@/pages/DailySchedules.vue'),
    meta: {
      title: '番組表',
    },
  },
  {
    path: '/search',
    component: () => import('@/pages/Search.vue'),
    meta: {
      title: '検索',
    },
  },
  {
    path: '/present',
    component: () => import('@/pages/Present.vue'),
    meta: {
      title: 'プレゼント',
    },
  },
  {
    path: '/mylist',
    component: () => import('@/pages/Mylist.vue'),
    meta: {
      title: 'お気に入り',
    },
  },
  {
    path: '/news',
    component: () => import('@/pages/News.vue'),
    meta: {
      title: 'お知らせ',
    },
  },
  {
    path: '/other',
    component: () => import('@/pages/Other.vue'),
    meta: {
      title: 'その他',
    },
  },
  {
    path: '/survey',
    component: () => import('@/pages/Survey.vue'),
    meta: {
      layout: 'none-footer',
      title: 'アンケート',
    },
  },
];

if (import.meta.env.MODE !== 'prod') {
  routes.push({
    path: '/dev',
    component: () => import('@/pages/Dev.vue'),
  });
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// nextはtoとfromを記載しないと使えない
router.beforeEach(async (to, from, next) => {
  /**
   * NOTE: pathが同じで、初回起動時ではない場合(from.meta.titleで判定)は、メンテナンスチェックを行わない
   */
  if (to.path === from.path && from.meta.title) {
    next();
    return;
  }

  next(await new MaintenanceCheck(to.path).doCheck());
});

router.afterEach((to) => {
  // タイトル設定
  const BASE_TITLE = import.meta.env.VITE_APP_TITLE as string;
  document.title = to.meta.title ? `${BASE_TITLE} | ${to.meta.title}` : BASE_TITLE;
});

export default router;
